import KendoTimePickerMixin from './KendoTimePickerMixin'

export default {
    name: 'kendo-timepicker',
    mixins: [ KendoTimePickerMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoTimePicker/index.js